import { ROLE_LABELS } from "../lib/permissions";
import type { Role } from "../lib/types";
import { StatusPill } from "./StatusPill";

export function RoleBadge({ role }: { role: Role }) {
  return <StatusPill tone={role === "owner" ? "progress" : "neutral"}>{ROLE_LABELS[role]}</StatusPill>;
}
